module.exports = __webpack_public_path__ + "f21cfb90e6214603a76037b362757163.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/assets/right-fold.svg
 ** module id = 816
 ** module chunks = 0
 **/